export default __webpack_public_path__ + "static/media/22.257e53a4.png";